import {useCallback} from 'react'
import {useGameStore} from '../store/GameStoreContext'
import {useIsReplay} from '../store/selectors/useIsReplay'
import {useIsMyVotePending} from '../store/selectors/useIsMyVotePending'
import {VoteTypes} from '@colonist/game-base-types'

export const useRequestPause = () => {
    const togglePause = useGameStore((state) => state.gamePause.togglePause)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const isReplay = useIsReplay()

    const requestPause = useCallback(() => {
        if(isPaused) return
        if(isReplay) return

        togglePause()
    }, [isPaused, isReplay, togglePause])

    return requestPause
}

export const useRequestResume = () => {
    const togglePause = useGameStore((state) => state.gamePause.togglePause)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const isReplay = useIsReplay()
    const isMyVotePending = useIsMyVotePending()
    const onVoteAccept = useGameStore((state) => state.gameVote.onVoteAccept)
    const voteState = useGameStore((state) => state.gameVote.voteState)

    const requestResume = useCallback(() => {
        if(!isPaused) return
        if(isReplay) return

        if(isMyVotePending && voteState?.type === VoteTypes.TogglePause) {
            onVoteAccept(voteState.id)
        } else {
            togglePause()
        }
    }, [isPaused, isReplay, togglePause, isMyVotePending, onVoteAccept, voteState])

    return requestResume
}
